import http from '../../services/httpClient';

/**
 * Every call the Not in Recipe popup makes, normalised to
 *   { ok: true, ...body }  |  { ok: false, status, code, error, details, items }
 * (the notInMenuApi.js pattern). httpClient throws for 4xx/5xx but RETURNS a 403 as
 * { success: false } — so success is checked explicitly, or a refused write would read as
 * done. Successful POSTs already fire the app-wide data-changed signal inside httpClient.
 */
const failure = (status, data, fallback) => ({
  ok: false,
  status,
  code: (data && data.code) || 'REQUEST_FAILED',
  error: (data && data.error) || fallback,
  details: (data && data.details) || null,
  items: data && Array.isArray(data.items) ? data.items : null,
  // Which item a refused answer was about (BAD_RATE, ITEM_NOT_FOUND).
  itemId: data && data.item_id !== undefined ? data.item_id : null,
});

const settle = async (call, fallback) => {
  try {
    const res = await call();
    if (!res || res.success !== true) return failure(403, res, fallback);
    return { ok: true, ...res };
  } catch (err) {
    return failure(err?.status || 0, { ...(err?.data || {}), error: err?.data?.error || err?.message }, fallback);
  }
};

const enc = encodeURIComponent;

export const checkNotInRecipe = (through) =>
  settle(() => http.get(`/not-in-recipe?through=${enc(through)}`), "Couldn't check items.");
export const saveAnswers = (through, answers) =>
  settle(() => http.post('/not-in-recipe/answers', { through, answers }), "Couldn't save the answers.");
export const mergeIngredient = (through, sourceItemId, targetItemId) =>
  settle(() => http.post('/not-in-recipe/merge', { through, source_item_id: sourceItemId, target_item_id: targetItemId }), "Couldn't merge these items.");
export const undoMerge = (logId) =>
  settle(() => http.post(`/not-in-recipe/merge/${enc(logId)}/undo`, {}), "Couldn't undo the merge.");

/**
 * Does a count dated `closingDate` reach the end of the month it closes? The client twin of
 * the server's rule (backend utils/eomPeriod: a count in the first 7 days of a month closes
 * the month before) — used only to skip the check for a mid-month count. The server decides.
 */
const CLOSING_GRACE_DAYS = 7;
export function reachesMonthEnd(closingDate) {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(closingDate || ''));
  if (!m) return false;
  const [y, mo, d] = [Number(m[1]), Number(m[2]), Number(m[3])];
  const shifted = new Date(Date.UTC(y, mo - 1, d - CLOSING_GRACE_DAYS));
  const lastDay = new Date(Date.UTC(shifted.getUTCFullYear(), shifted.getUTCMonth() + 1, 0));
  return closingDate >= lastDay.toISOString().slice(0, 10);
}

export const HEADS = [
  ['kitchen_use', 'Kitchen use'],
  ['staff_meal', 'Staff meal'],
  ['packaging', 'Packaging'],
  ['cleaning', 'Cleaning'],
  ['other_supplies', 'Other supplies'],
];
export const HEAD_LABEL = Object.fromEntries(HEADS);
